<template>
 <div class="approve-box">
  <!-- 刷新弹窗 -->
  <ReloadDialog
    ref="reloadDialogRef"
    @reloadClick="reloadClick"
    :controlBtnName="reloadBtnName"
  />
  <!-- 提交其他项弹窗 -->
  <SubmitOtherDialog
    ref="submitOtherDialogRef"
    @submitOtherData="submitOtherData"
    :controlBtnName="submitOtherBtnName"
    :receivableIds="receivableIds"
    :tableData="tableData"
    :isSubmitOther="isSubmitOther"
  />
 </div>
</template>

<script>
import ReloadDialog from './components/ReloadDialog.vue'
import SubmitOtherDialog from './components/SubmitOtherDialog.vue'
import { receivableFilterReceivable } from '@/api/domain/returnLease'

export default {
  components: {
    ReloadDialog,
    SubmitOtherDialog,
  },
  props: {
    dingTalkShow: {
      type: Boolean,
      default: false,
    },
    sunbmitFun: {
      type: Function,
      default: () => {},
    },
    isReload: {
      type: Boolean,
      default: true,
    },
    isSubmitOther: {
      type: Boolean,
      default: true,
    },
    tableData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      receivableIds: [], // 审核中的数据Id
    }
  },
  watch: {

  },
  computed: {
    reloadBtnName() {
      return this.isReload ? '刷新' : '我知道了'
    },
    submitOtherBtnName() {
      return this.isSubmitOther ? '提交其他应收' : '我知道了'
    },
  },
  mounted() {
  },
  methods: {
    // 提交钉钉审批
    sunbmitDdApprove() {
      // 是否启用
      if (this.dingTalkShow) {
        // 校验是否有审核中的数据
        this.receivableFilterReceivable()
      } else {
        this.showDialog('reloadDialogRef')
      }
    },
    // 检查是否有审核中的数据
    async receivableFilterReceivable() {
      const receivableIds = this.tableData.map((item) => item.receiveId || item.id || item)
      this.receivableIds = []
      const { data } = await receivableFilterReceivable({ receivableIds })
      if (data && data.length) {
        this.receivableIds = data
        this.showDialog('submitOtherDialogRef')
      } else {
        this.sunbmitFun(this.receivableIds)
      }
    },
    // 提交其他数据
    submitOtherData() {
      this.isSubmitOther && this.sunbmitFun(this.receivableIds)
    },
    // 刷新功能
    reloadClick() {
      this.isReload && this.$emit('reloadClick')
    },
    // 弹窗开关控制
    showDialog(type) {
      this.$refs[type].dialogVisible = !this.$refs[type].dialogVisible
    },
  },
}
</script>

<style scoped lang='scss'>
.dialog-content{
  padding: 10px;
  padding-bottom: 30px;
}

</style>
